<template>
	<v-card
		flat
		color="secondary"
		class="estate-container"
		dark
	>
		<v-card-title primary class="title">
			Real Estate Detail 
		</v-card-title>

		<v-card-title primary class="font-weight-medium ">
			{{ selectedEstate ? selectedEstate.name : 'No Estate selected' }}
		</v-card-title>

		<v-card-text v-if="!selectedEstate">
			Select an estate from the map to see its details.
		</v-card-text>

		<v-card-text v-if="selectedEstate">
			<v-layout row wrap>
				<v-flex xs6>
					<h3 class="font-weight-black">
						Value Re20 : {{ selectedEstate.buy_cost }} 
					</h3>

					<h4 class="font-weight-light">
						Value € : {{ selectedEstate.buy_cost }}
					</h4>

					<h4 class="font-weight-light">
						Stamp Duty € : {{ selectedEstate.Stamp_duty }}
					</h4>

					<h4 class="font-weight-light">
						Notary Fee € : {{ selectedEstate.Notary_fee }}
					</h4>

					<!--
					<h6 class="subheading font-weight-regular">
						Value Re20 : 0.000
					</h6>
					-->
				</v-flex>
				<v-flex xs6>
					<!-- <img
						:src="selectedEstate.photos ? selectedEstate.photos[1] : require('../assets/estate-placeholder.jpg')"
						width="100px" 
					> -->
					<v-carousel
						next-icon="fas fa-chevron-circle-right"
						prev-icon="fas fa-chevron-circle-left"
						delimiter-icon="fas fa-circle"
						hide-controls
						height="200px"
					>
						<v-carousel-item
							v-for="(photo,key) in selectedEstate.photos"
							:key="key"
							:src="photo"
						/>
					</v-carousel>
				</v-flex>
			</v-layout>
		</v-card-text>

		<template>
			<v-tabs
				v-if="selectedEstate"
				v-model="tab"
				color="secondary"
				grow
				>
				<v-tabs-slider color="white" />

				<v-tab
					v-for="item in items"
					:key="item"
					>
					{{ item }}
				</v-tab>
			</v-tabs>
		</template>

		<v-card
			flat
			color="primary"
			dark
			height="100%"
		>
			<v-tabs-items 
				v-if="selectedEstate"
				v-model="tab"
				class="fixed"
				
			>
				<v-tab-item
					v-for="item in items"
					:key="item"
				>
					<v-layout fill-height>
						<v-flex d-flex>
							<estate-details-info 
								v-if="item === 'Info'"
								:info="selectedEstate.description"
								:position="selectedEstate.address"
								
							/>
							<estate-details-cost 
								v-if="item === 'Expenses'"
								:fixed-expenses="selectedEstate.fixed_expenses"
							/>
							<estate-details-documents 
								v-if="item === 'Documents'"
								:selected-estate="selectedEstate"
							/>
							<estate-details-trade 
								v-if="item === 'Trade'"
								:selected-estate="selectedEstate"
								@onClickBuy="onBuyButton"
							/>
							<estate-details-chat
								v-if="item === 'Chat'"
							/>
						</v-flex>
					</v-layout>
				</v-tab-item>
			</v-tabs-items>
		</v-card>
	</v-card>
</template>

<script>
import { mapActions } from 'vuex'
export default {
	props: ['selectedEstate'],
  
	data () {
		return {
			tab: null,
			items: [
				'Info', 'Expenses', 'Documents', 'Trade', 'Chat'
			],
		}
	},
	watch: {
	},
  
	methods: {
		...mapActions (['buyEstate']),
		onBuyButton () {
			this.buyEstate (this.selectedEstate)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';

.estate-container {
	border: 1px solid white !important;
	min-height: 650px;
	max-height: 650px;
}

.thumbnail {
  width: 200px;
  height: 150px;
  object-fit: cover;
}

.fixed {
	min-height: 100%;
	max-height: 100%;
	overflow-y: scroll;
	overflow-x: hidden;
}
</style>